<div fxLayout="column">
  <mat-card>
    <mat-card-actions align="start">
      <div fxLayout="5px;">
            <span>
              <img alt="logo P8"
                   style="width: 110px;"
                   src="./assets/logo-p8-secondaire.png"/>
            </span>
        <span style="border-left: 2px solid rgb(154, 154, 154); height: 36px; margin-right: 5px;"></span>
        <span class="mat-title" style="padding-top: 3px;">DAR</span>
      </div>
    </mat-card-actions>
    <mat-card-subtitle>
      Cet espace vous permet d'effectuer des demandes de recrutement et de suivre vos dossiers soumis à validation par la Dipefas et commission.
    </mat-card-subtitle>
    <mat-card-content fxLayout="column">
      <div *ngIf="environment.env==='test'" style="padding-bottom: 10px;">
        <mat-icon aria-hidden="true" color="primary">warning</mat-icon>
        <strong>
          <mark>Cet espace est l'application de TEST afin de prendre en main l'outil ou de détecter des anomalies,
            aucune donnée / information ne sera conservée et ne représente en aucun cas de réelles informations à exploiter</mark>
        </strong>
        <mat-icon aria-hidden="true" color="primary">warning</mat-icon>
      </div>
    </mat-card-content>
  </mat-card>

  <app-model-pj-view></app-model-pj-view>

  <router-outlet></router-outlet>

</div>
